var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.473 26C10.129 26.0043 9.00945 24.9598 8.89936 23.5986L8 12C8 12 29.2657 12.0073 29.3572 12.0203C30.4038 12.1743 31.1316 13.1622 30.98 14.227L29.6231 23.7541C29.4416 25.0441 28.3535 26.0029 27.0709 26H11.473Z",
    fill: "#EB5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58343 5.4165L8.0501 6.0165L9.6551 25.1382C9.78343 26.6998 11.0884 27.8982 12.6551 27.8932H30.8368C32.3318 27.8965 33.6001 26.7965 33.8118 25.3165L35.3934 14.3865C35.5701 13.1648 34.7218 12.0315 33.5018 11.8548C33.3951 11.8398 8.60677 11.8315 8.60677 11.8315",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5418 17.9913H28.1634",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.924 33.6709C12.4256 33.6709 12.8306 34.0776 12.8306 34.5776C12.8306 35.0792 12.4256 35.4859 11.924 35.4859C11.4223 35.4859 11.0173 35.0792 11.0173 34.5776C11.0173 34.0776 11.4223 33.6709 11.924 33.6709Z",
    fill: "#130F26",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7245 33.6709C31.2261 33.6709 31.6328 34.0776 31.6328 34.5776C31.6328 35.0792 31.2261 35.4859 30.7245 35.4859C30.2228 35.4859 29.8178 35.0792 29.8178 34.5776C29.8178 34.0776 30.2228 33.6709 30.7245 33.6709Z",
    fill: "#130F26",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/Buy.c6fb5c63.svg";
export { ForwardRef as ReactComponent };